export default "__VITE_ASSET__DNE7QoRm__"